import "./style/index.css";
import "animate.css";
import '@fontsource/noto-sans';

import App from "./components/app";

export default App;
